import { Home } from '../features/Home';

export const HomePage = () => {
  return <Home />;
};
